export default "__VITE_ASSET__PQ90vj9U__"